import React from "react";
import styled from "styled-components";

import {
  useQuerySearchUserFavorites,
  useAppContext,
} from "@examspark/common-app";
import { VSpace } from "@examspark/common-ui";

import BrowseList from "../../components/browse/BrowseList";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";

const PageSections = styled(VSpace)`
  gap: 3rem;
`;

const FavoritesRoute = () => {
  const [state] = useAppContext();
  const { data: favorites } = useQuerySearchUserFavorites(state.user?.id);

  return (
    <PageSections>
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <PageTitle>Favorites</PageTitle>
      </PageHead>
      <BrowseList query={""} data={favorites ?? []} />
    </PageSections>
  );
};

export default FavoritesRoute;
